<template>
  <div class="content-tab port-statistics"  ref="chart">
    <div class="content-body" v-if="!isShowDetail" >
      <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
      <div class="content-headerbar">
        <div class="content-headerbar-content">
          <div class="left">
            <div class="q-icon-button leftwrapper" :class="{'selected': viewType==='list'}">
              <div class="icon-list" @click="chooseViewType('list')">
              </div>
            </div>
            <div class="q-icon-button rightwrapper" :class="{'selected': viewType==='report'}">
              <div class="icon-report" @click="chooseViewType('report')">
              </div>
            </div>
            <div style="display: inline-flex; margin-left:20px;" v-if="viewType !== 'list'">
              <div class="title" style="line-height:30px;">{{$t("port.selectType")}}</div>
              <q-select class="q-select" :value="selectType" :options-array="menuOptions" @change="onMenuChange"></q-select>
            </div>
          </div>
          <div class="right">
            <div class="divide" v-if="viewType === 'list'"></div>
            <button class="q-button blue-btn-full" @click="onClearClick" :title="$t('clear')">{{$t('clear')}}</button>
          </div>
        </div>
      </div>
      <div class="content-item" v-if="viewType === 'list'">
        <div class="port-statistic-table">
          <fixed-table ref="portTable" :data="ports" :use-page="false" :header-height="50" class="group-table">
            <div class="right-header" slot="right-header" style="display:flex;">
              <column style="width: 16%;">{{$t('overview.portNo')}}</column>
              <column style="width: 21%;">
                <div class="grid-container">
                  <div class="grid-item item1">{{$t('port.bytes')}}</div>
                  <div class="grid-item item2">{{$t('received')}}</div>
                </div>
              </column>
              <column style="width: 21%;">
              <div class="grid-container">
                  <div class="grid-item item1"></div>
                  <div class="grid-item item2">{{$t('transmitted')}}</div>
                </div></column>
              <column style="width: 21%;">
                <div class="grid-container">
                  <div class="grid-item item1">{{$t('port.errors')}}</div>
                  <div class="grid-item item2">{{$t('received')}}</div>
                </div>
              </column>
              <column style="width: 21%;">
                <div class="grid-container">
                  <div class="grid-item item1"></div>
                  <div class="grid-item item2">{{$t('port.fcsError')}}</div>
                </div></column>
            </div>
            <template slot="rows" slot-scope="props">
              <div class="link-row" v-if="checkShow(props.data.key)">
                <row class="right" :props="props">
                  <div class="data" style="width: 16%;">{{props.data.key}}</div>
                  <div class="data border-left" style="width: 21%;">
                    {{props.data.val.RxOctets}}
                  </div>
                  <div class="data" style="width: 21%;">
                    {{props.data.val.TxOctets}}
                  </div>
                  <div class="data border-left" style="width: 21%;">
                    {{props.data.val.RxErrors}}
                  </div>
                  <div class="data" style="width: 21%;">
                    {{props.data.val.FCSErrors}}
                  </div>
                  <!-- <div class="data" style="width: 5%;" @click="onClickPort(props.data.key)">
                    <span class="icon-arrow_right"></span>
                  </div> -->
                </row>
              </div>
            </template>
          </fixed-table>
        </div>
      </div>
      <div class="content-item" v-else>
        <scrollbar ref="scrollbar" class="scrollbar-body">
          <div class="chart-type" v-if="sysBoard && (sysBoard.Product.includes('M408') || sysBoard.Product.includes('M2108') || sysBoard.Product.includes('M5216') || sysBoard.Product.includes('M2106'))">
            <div class="chart">
              <!-- <div class="bar" style="background:blue;"></div> -->
              <ve-histogram ref="oneG" class="bar" :data="chartData[(selectType === 'bytes') ? 'bytes' : 'errors']" :colors="chartConfig.colors" :settings="chartConfig.setting" :y-axis="chartConfig.yAxis" :extend="chartConfig.extend" :grid="chartConfig.grid" width="auto" :height="selHeight" :after-config="afterConfig"></ve-histogram>
            </div>
            <div class="chart">
              <!-- <div class="bar" style="background:red;"></div> -->
              <ve-histogram ref="tenG" class="bar" :data="tenGchartData[(selectType === 'bytes') ? 'bytes' : 'errors']" :colors="chartConfig.colors" :settings="chartConfig.setting" :y-axis="chartConfig.yAxis" :extend="chartConfig.tenExtend" :grid="chartConfig.tenGrid" width="auto" :height="selHeight" :after-config="afterConfig"></ve-histogram>
            </div>
          </div>
          <div :class="chartClass" v-else >
            <div class="m120x">
              <ve-histogram ref="tenG" class="bar" :data="tenGchartData[(selectType === 'bytes') ? 'bytes' : 'errors']" :colors="chartConfig.colors" :settings="chartConfig.setting" :y-axis="chartConfig.yAxis" :extend="chartConfig.tenExtend" :grid="chartConfig.tenGrid" :width="chartWidth" :height="selHeight" :after-config="afterConfig"></ve-histogram>
            </div>
          </div>
        </scrollbar>
      </div>
    </div>
    <!-- <detail v-else :onChange=onBack :selectPort="selectPort" :port="ports[selectPort - 1].val" :onSelectChange=onDetailChange></detail> -->
    <popup-confirm name="port-statistics-delete-modal" :dialog-header="$t('port.warningHeader')" :dialog-message="$t('port.clearInfo')" icon="w" type="c" :callback="goClear" />
  </div>
</template>

<script>
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import VeHistogram from 'v-charts/lib/histogram.common'
import qSelect from './module/Select.vue'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'PortStatistics',
  components: {
    fixedTable,
    row,
    column,
    // detail,
    VeHistogram,
    qSelect
  },
  data () {
    return {
      selectPort: null,
      ports: [],
      isShowLoading: false,
      viewType: 'report',
      isShowDetail: false,
      chartWidth: 'auto',
      chartClass: 'chart-type',
      chartConfig: {
        colors: ['#7ED321', '#2BBAF0'],
        yAxis: {
          name: this.$t('port.bytes'),
          nameTextStyle: {
            width: 25,
            fontWeight: 'bold'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          axisLabel: {
            color: '#000000'
          }
        },
        grid: {
          show: true,
          borderColor: 'none',
          right: 50,
          top: 30,
          bottom: 30
        },
        tenGrid: {
          show: true,
          borderColor: 'none',
          right: 50,
          top: 30,
          bottom: 30
        },
        extend: {
          series: {
            barWidth: 12,
            cursor: 'default',
            barMinHeight: 2
          },
          xAxis: {
            name: this.$t('overview.portNo'),
            nameLocation: 'end',
            nameGap: 10,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#8EA0F9',
                type: 'solid',
                width: 2
              }
            },
            axisLabel: {
              color: '#000000'
            },
            nameTextStyle: {
              color: '#000000',
              fontWeight: 'bold'
            }
          },
          legend: {
            show: false
          }
        },
        tenExtend: {
          series: {
            barWidth: 12,
            cursor: 'default',
            barMinHeight: 2
          },
          xAxis: {
            name: this.$t('overview.portNo'),
            nameLocation: 'end',
            nameGap: 10,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#8EA0F9',
                type: 'solid',
                width: 2
              }
            },
            axisLabel: {
              color: '#000000'
            },
            nameTextStyle: {
              color: '#000000',
              fontWeight: 'bold'
            }
          },
          legend: {
            selectedMode: false,
            itemWidth: 10,
            itemHeight: 10,
            right: 5,
            bottom: 0,
            formatter: this.legendFormatter,
            data: [
              {
                name: 'Received',
                icon: 'circle'
              }, {
                name: 'Transmitted',
                icon: 'circle'
              }
            ]
          }
        }
      },
      chartData: {
        bytes: {
          columns: ['portNum', 'Received', 'Transmitted'],
          rows: []
        },
        errors: {
          columns: ['portNum', 'Received', 'FCSErrors'],
          rows: []
        }
      },
      tenGchartData: {
        bytes: {
          columns: ['portNum', 'Received', 'Transmitted'],
          rows: []
        },
        errors: {
          columns: ['portNum', 'Received', 'FCSErrors'],
          rows: []
        }
      },
      selectType: 'bytes',
      menuOptions: [
        { value: 'bytes', label: 'port.bytes' },
        { value: 'errors', label: 'port.errors' }
      ]
    }
  },
  beforeDestroy () {
    clearInterval(this.systemInterval)
  },
  created: async function () {
    this.getPortStatistics().then(res => {
      if (res.status === 200) {
        let data = (res.data)
        let detail = data.result
        detail.splice(this.portNumber, detail.length - this.portNumber)
        this.ports = detail
        this.setChartData()
        this.isShowLoading = false
        this.$forceUpdate()
      }
    })
    this.getData()
  },
  watch: {
    showQuickHelp (value) {
      let event
      let me = this
      this.chartWidth = (value) ? '100%' : 'auto'
      this.chartClass = (value) ? 'chart-open' : 'chart-type'
      if (typeof (Event) === 'function') {
        event = new Event('resize')
      } else {
        event = document.createEvent('Event')
        event.initEvent('resize', true, true)
      }
      setTimeout(() => {
        if (!value) window.dispatchEvent(event)
        if ((me.sysBoard.Product.includes('M408') || me.sysBoard.Product.includes('M2108') || me.sysBoard.Product.includes('M5216') || me.sysBoard.Product.includes('M2106'))) window.dispatchEvent(event)
        me.chartClass = 'chart-type'
      }, 400)
    },
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.systemInterval)
        this.systemInterval = null
      }
    },
    currentUser: {
      handler (value) {
        if (!value) {
          clearInterval(this.systemInterval)
        }
      },
      immediate: true,
      deep: true
    },
    lang: {
      handler (value) {
        setTimeout(() => {
          if (this.$refs.tenG) {
            // this.$refs.tenG.$options.propsData.yAxis.name = this.$t('port.bytes')
            this.$refs.tenG.$options.propsData.extend.xAxis.name = this.$t('overview.portNo')
          }
          if (this.$refs.oneG) {
            // this.$refs.oneG.$options.propsData.yAxis.name = this.$t('port.bytes')
            this.$refs.oneG.$options.propsData.extend.xAxis.name = this.$t('overview.portNo')
          }
          if (this.selectType === 'errors') {
            this.chartConfig.yAxis.name = this.$t('port.packets')
          } else {
            this.chartConfig.yAxis.name = this.$t('port.bytes')
          }
          this.$forceUpdate()
        }, 200)
      },
      immediate: true
    }
  },
  methods: {
    getData: function (isFromClear) {
      if (!isFromClear) {
        this.isShowLoading = true
      }
      let me = this
      this.systemInterval = setInterval(() => {
        try {
          me.getPortStatistics()
            .then(res => {
              if (res.status === 200) {
                let data = (res.data)
                let detail = data.result
                detail.splice(me.portNumber, detail.length - me.portNumber)
                me.ports = detail
                me.setChartData()
                me.isShowLoading = false
                me.$forceUpdate()
              }
            })
        } catch (err) {
          this.$log.error(err)
        }
      }, this.intervalTime)
    },
    setChartData: function (isChange) {
      let me = this
      let rxValue = null
      let txValue = null
      let temp = []
      let tenTemp = []
      let minNumber = (this.sysBoard.Product.includes('M408') || this.sysBoard.Product.includes('M2108')) ? 8 : 0
      if (this.sysBoard.Product.includes('M2106')) minNumber = 6
      if (this.sysBoard.Product.includes('M5216')) minNumber = 16
      switch (this.selectType) {
        case 'bytes':
          rxValue = 'RxOctets'
          txValue = 'TxOctets'
          break
        case 'errors':
          rxValue = 'RxErrors'
          txValue = 'FCSErrors'
          break
      }
      this.ports.forEach(element => {
        let number = parseInt(element.key)
        let datas = (this.selectType === 'bytes') ? {
          'portNum': number,
          'Received': element.val[rxValue],
          'Transmitted': element.val[txValue]
        } : {
          'portNum': number,
          'Received': element.val[rxValue],
          'FCSErrors': (element.val[txValue]) ? element.val[txValue] : 0
        }
        if (number > minNumber && tenTemp.length < me.portNumber - minNumber) {
          tenTemp.push(datas)
        } else if (temp.length < (me.sysBoard.Product.includes('M5216')) ? 16 : 8) {
          temp.push(datas)
        }
      })
      this.chartData[this.selectType].rows = temp
      this.tenGchartData[this.selectType].rows = tenTemp
      this.$forceUpdate()
    },
    onMenuChange: function (value) {
      if (value === 'errors') {
        this.chartConfig.yAxis.name = this.$t('port.packets')
      } else {
        this.chartConfig.yAxis.name = this.$t('port.bytes')
      }
      this.selectType = value
      this.setChartData(true)
    },
    setDataToZero: function () {
      this.ports.forEach((element, index) => {
        for (const key in element.val) {
          this.ports[index].val[key] = 0
        }
      })
      for (const key in this.tenGchartData) {
        if (this.tenGchartData.hasOwnProperty(key)) {
          const element = this.tenGchartData[key]
          element.rows.forEach((item, index) => {
            this.tenGchartData[key].rows[index].Received = 0
            this.tenGchartData[key].rows[index].Transmitted = 0
            this.tenGchartData[key].rows[index].FCSErrors = 0
          })
        }
      }
      for (const key in this.chartData) {
        if (this.chartData.hasOwnProperty(key)) {
          const element = this.chartData[key]
          element.rows.forEach((item, index) => {
            this.chartData[key].rows[index].Received = 0
            this.chartData[key].rows[index].Transmitted = 0
            this.chartData[key].rows[index].FCSErrors = 0
          })
        }
      }
      this.getData(true)
    },
    onClearClick: function () {
      this.$modal.show('port-statistics-delete-modal')
    },
    goClear: function () {
      this.$modal.hide('port-statistics-delete-modal')
      clearInterval(this.systemInterval)
      this.clearPortStatics()
        .then(res => {
          if (res.status === 200) {
            this.setDataToZero()
            this.$forceUpdate()
          }
        })
        .catch(error => {
          this.$log.error(error)
        })
    },
    chooseViewType: function (type) {
      this.viewType = type
    },
    afterConfig: function (options) {
      if (this.selectType === 'bytes') {
        options.legend.data = [{
          name: 'Received',
          icon: 'circle'
        }, {
          name: 'Transmitted',
          icon: 'circle'
        }]
      } else {
        options.legend.data = [{
          name: 'Received',
          icon: 'circle'
        }, {
          name: 'FCSErrors',
          icon: 'circle'
        }]
      }
      return options
    },
    chartTooltipFormatter: function (params) {
      // return this.$t('dashboard.portNo') + ' ' + params[0].axisValueLabel + '<br/>' + params[0].value + this.$t('poe.consumption.watt')
    },
    legendFormatter: function (name) {
      let result = ''
      if (this.selectType === 'bytes') {
        if (name === 'Received') {
          result = this.$t('received')
        } else {
          result = this.$t('transmitted')
        }
      } else {
        if (name === 'Received') {
          result = this.$t('received')
        } else {
          result = this.$t('port.fcsError')
        }
      }
      return result
    },
    checkShow: function (key) {
      if (this.sysBoard.Product.includes('M2108')) {
        if (key > 10) {
          return false
        }
        return true
      } else if (this.sysBoard.Product.includes('M804')) {
        if (key > 8) {
          return false
        }
        return true
      } else if (this.sysBoard.Product.includes('M5216')) {
        if (key > 17) {
          return false
        }
        return true
      }
      return true
    },
    ...mapActions(['getPortResource', 'getPortGroup', 'getPortStatisticsEthernet', 'getPortStatistics', 'clearPortStatics'])
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      fwinfo: state => state.module.fwinfo,
      sysBoard: state => state.module.sysBoard,
      portNumber: state => state.module.portNum,
      showFullLoading: state => state.module.showFullLoading,
      deviceCollapsed: state => state.app.deviceCollapsed,
      showQuickHelp: state => state.app.showQuickHelp,
      intervalTime: state => state.app.intervalTime
    }),
    selHeight () {
      if (!this.deviceCollapsed) {
        return '250px'
      } else {
        return '190px'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@import '../assets/scss/variables.scss';
.content-tab.port-statistics {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .content-headerbar-content {
    display: flex;
    justify-content: space-between;
    padding: 20px 20px 10px 20px;
    .divide {
      margin: 5px 20px 5px 20px;
      width: 1px;
      height: 20px;
      border: 1px solid #F1F1F1;
    }
    >.left {
      color: #000000;
      line-height: 30px;
      display: flex;
      .title {
        font-family: 'Roboto-M' !important;
        padding-right: 5px;
      }
    }
    >.right {
      display: flex;
      padding-right: 20px;
      .clear-btn {
        margin-right: 7px;
      }
    }
  }
  .content-body {
    .scrollbar-body {
      height: calc(100% - 10px);
    }
    .content-item {
      height: calc(100% - 60px);
      padding: 0px 20px;
      margin-bottom: 0px;
      .port-statistic-table {
        height: 100%;
        color: #000000;
        >.qweb-table {
          height: calc(100% - 10px);
          >.body {
            height: calc(100% - 50px);
            max-height: calc(100% - 50px);
            > .rows > .scroll-content .link-row > .data-row > .data {
              &.border-left {
                border-left: 1px solid #F1F1F1;
              }
              .arraw-right {
                width: 20px;
                height: 20px;
                fill: #2F2F2F;
                &:hover {
                  cursor: pointer;
                }
              }
            }
          }
          .qweb-column {
            &:first-child {
              padding: 0px 16px;
            }
            padding: 0px;
          }
        }
        &.per-Port-content {
          margin: 0px 20px;
          overflow-y: scroll;
          >.content-body-header {
            justify-content: flex-start;
            .title {
              width: 100px;
            }
            .filter-port {
              width: 100px;
            }
          }
          >.content {
            display: flex;
            >.sub-content {
              border: 1px solid #F1F1F1;
              border-radius: 12px;
              width: 100%;
              height: auto;
              margin-bottom: 10px;
              padding: 10px 20px;
              &:first-child {
                margin-right: 20px;
              }
              >.sub-content-header {
                font-size: 14px;
                color: #000000;
                margin-bottom: 4px;
                font-weight: 500;
              }
              >.sub-content-body {
                font-size: 13px;
                line-height: 22px;
                margin-left: 20px;
                .title {
                  width: 150px;
                }
                .value {
                  color: #6370AF;
                }
              }
            }
          }
        }
      }
      .chart-type {
        width: 100%;
        .chart:first-child {
          min-width: 450px;
          border-right: 1px solid #979797;
        }
        .chart {
          display: inline-block;
          width: calc(50% - 10px);
          min-width: 400px;
        }
        .m120x {
          width: 100% !important;
          border-right: none !important ;
        }
      }
      .chart-open {
        width: calc(100% - 150px);
        .m120x {
          width: calc(100% - 150px) !important;
          border-right: none !important ;
        }
      }
    }
  }
  .table-row {
    display: table-row;
    .title {
      display: table-cell;
    }
  }
  .content-body-footer {
    top: calc(100% - 50px) !important;
    height: 30px;
    margin: 10px 20px;
  }
  .qweb-column {
    height: 50px;
    line-height: 50px;
  }
  .grid-container {
    grid-template-columns: 100% 100%;
  }
  .grid-item {
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item1 {
    grid-column: 1 / span 2;
    grid-row: 1;
    color: #000000;
    font-family: 'Roboto-M' !important;
    border-bottom: 1px solid #C8C8C8;
    padding-left: 16px;
  }
  .item2 {
    grid-column: 1;
    grid-row: 2 / span 1;
    padding-left: 16px;
  }
  .item3 {
    padding-left: 10px;
  }
  .icon-report, .icon-list, .icon-arrow_right {
    &:before {
      vertical-align: middle;
    }
  }
  .icon-report{
    background: none;
    padding: 1px 0px 0px 2px;
  }
  .icon-list {
    background: none;
    padding: 1px 0px 0px 7px;
  }
  .icon-arrow_right {
    cursor: pointer;
    &:hover {
      color: $btn-hover;
    }
    &:active {
      color: $btn-active;
    }
    &:focus {
      color: $btn-focus;
    }
  }
  .q-select .display-label {
      font-size: 13px;
      color: #000;
    }
    .q-select {
      width: 150px;
      height: 30px;
      border: 1px solid #979797 !important;
      border-radius: 4px;
      vertical-align: middle;
      /deep/ .dropdown-menu {
        left: -1px;
        width: 200px;
        height: auto;
        overflow: auto;
      }
      /deep/ .display-label {
        font-size: 13px !important;
        color: #2F2F2F !important;
        line-height: 30px !important;
      }
      &::after {
        background-color: #000;
        top: -25px;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/PortStatistics.vue